import React from 'react';
import { LoadingSpinner } from '@corrprocanada/theme-kit/web';

// Theme-kit spinner used while a lazily loaded route's code is fetched.
// Full-page by default (centred in the viewport); `inline` keeps it compact for
// places where other content renders alongside it.
const RouteLoading = ({ title = 'Loading...', inline = false }) => (
	<div
		style={inline
			? { width: '100%', height: '100dvh', padding: 'var(--tk-spacing-4, 20px) 0' }
			: { width: '100%', height: '100dvh' }}
	>
		<LoadingSpinner text={title} />
	</div>
);

export default RouteLoading;
